import React from "react"

import { faChevronDown } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  Grid,
  LinearProgress,
  styled,
  Typography
} from "@mui/material"
import { Question } from "./Question"
import { useTranslation } from "react-i18next"

export const Area = (props) => {
  const { item, assignedCourses, areaIndex, translatedMomentTitle } = props
  const { t } = useTranslation()
  const [expanded, setExpanded] = React.useState(false)

  const handleChange = () => {
    setExpanded((p) => !p)
  }
  const totalQuestions = item.questions.length

  const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 4,
    backgroundColor: theme.palette.grey[200],
    "& .MuiLinearProgress-bar": {
      backgroundColor: theme.palette.primary[800]
    }
  }))

  const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => ({
    "& .MuiAccordionSummary-content": {
      margin: "18px 0"
    }
  }))

  return (
    <Accordion expanded={expanded} onChange={handleChange}>
      <StyledAccordionSummary
        sx={{ paddingX: "36px" }}
        expandIcon={<FontAwesomeIcon icon={faChevronDown} />}
        aria-controls="moment1-content">
        <Grid container alignItems="center" sx={{ margin: 0 }}>
          <Grid xs={12} item sm={7}>
            <Typography variant="bodyMedium">
              {translatedMomentTitle ? translatedMomentTitle : item.areaTitle}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={3}>
            <Grid container direction="column" justifyContent="flex-end">
              <Grid item>
                <Typography mb={1} variant="caption" color="textSecondary">
                  {item.totalCorrectAnswersCount} / {item.totalCorrectCount}{" "}
                  {t("learning.titles.number_correct", "correct number")}
                </Typography>
              </Grid>
              <Grid item>
                <Box width={1}>
                  <StyledLinearProgress
                    variant="determinate"
                    value={Math.round((100 / item.totalCorrectCount) * item.totalCorrectAnswersCount)}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </StyledAccordionSummary>
      <AccordionDetails>
        {/* list of <Question */}
        {item.questions.map((item, key) => {
          return (
            <Box marginBottom={2} key={key}>
              <Question item={item} totalQuestions={totalQuestions} index={key + 1} />
              <Divider light />
            </Box>
          )
        })}
      </AccordionDetails>
    </Accordion>
  )
}
